import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ads/acq/AdvertiseMiniLink.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ads/paid/paid-ads.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ads/paid/PaidAdCarouselClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ads/paid/PaidAdClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ads/promo/PromoDistrictSlot.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/apt/sub/apt-sub.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(main)/blog/ds2-blog.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(main)/blog/region/region.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ds/e/FooterTalkLink.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ds/e/HeaderAuth.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ds/e/SegmentTabs.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/shell/kd-shell.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/thumb/Thumb.tsx");
